import { render, staticRenderFns } from "./ConfirmProp.vue?vue&type=template&id=6986fcc2&"
import script from "./ConfirmProp.vue?vue&type=script&lang=js&"
export * from "./ConfirmProp.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmProp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports